<template>
	<div class="small-12" v-if="user">
		<section class="small-12 pageTitle flex justify-center">
			<div class="small-12 columns flex">
				<div class="small-12 large-5 columns">
					<h1 class="small-12 flex vertical-align">
						Properties 
					</h1>
				</div>
				<div class="small-12 large-7 columns searchContainer">
					<ul class="small-12 flex justify-right vertical-align">
						<li class="search large-5">
							<input class="border" type="text" placeholder="Search by Nickname" v-model="search_query">
							<i class="material-icons-outlined">search</i>
						</li>
						<li class="reportsMenu" v-if="future_item">
							<a class="flex justify-center borderRadius4">
								<i class="material-icons-outlined chartIcon flex justify-center vertical-align borderRadius4">insert_chart</i>
								<i class="material-icons-outlined flex justify-center vertical-align">arrow_drop_down</i>
							</a>
						</li>
						<li class="addMenu" v-if="user.relationships.company">
							<router-link :to="{ name: 'AddProperty' }" class="blueButton flex vertical-align justify-center borderRadius4">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
								Add Property
							</router-link>
						</li>
						<li class="addMenu" v-else>
							<router-link :to="{ name: 'AddCompany' }" class="purpleButton flex vertical-align justify-center borderRadius4">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
								Add Company
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<section class="small-12 propertiesListing flex justify-center">
			<div class="small-12 columns listingsTable">
				<div class="small-12 head border-bottom">
					<ul class="small-12 flex vertical-align">
						<li class="small-12 large-4 columns flex vertical-align">
							<span class="resultsTotal round flex justify-center vertical-align bgPrimaryBlue cWhite" v-tooltip="'Total Properties'">{{total_properties}}</span>
							<p class="flex vertical-align">
								Property
								<i class="material-icons outlined">arrow_drop_down</i>
							</p>
						</li>
						<li class="small-12 large-2 columns flex vertical-align">
							<p class="flex vertical-align">
								Balance
								<i class="material-icons outlined">arrow_drop_down</i>
							</p>
						</li>
						<li class="small-12 large-5 columns flex vertical-align end">
							<p class="flex vertical-align">
								Stats
								<i class="material-icons outlined">arrow_drop_down</i>
							</p>
						</li>
					</ul>
				</div>
				<div class="small-12 body">
					<div class="small-12" v-if="search_query">
						<ul class="small-12 columns flex" v-if="searchResults.length > 0">
							<li class="small-12" v-for="(property, index) in searchResults" :key="index">
								<property-listing :property="property"/>
							</li>
						</ul>
						<ul class="small-12 columns flex animated fadeIn" v-else>
							<li class="small-12">
								<div class="small-12 emptyResults flex justify-center">
									<picture class="small-12 flex justify-center">
										<img width="120" :src="empty_image" alt="Nestd Logo in a House">
									</picture>
									<h6 class="small-12 text-center">
										0 results found
									</h6>
									<p class="small-12 text-center">
										No property results have been found with that nickname.
									</p>
								</div>
							</li>
						</ul>
					</div>
					<div class="small-12" v-if="!search_query">
						<ul class="small-12 columns flex" v-if="properties.length > 0">
							<li class="small-12" v-for="(property, index) in properties" :key="index">
								<property-listing :property="property" :company="company" @deleteProperty="updateProperties"/>
							</li>
						</ul>
						<ul class="small-12 columns flex animated fadeIn" v-else>
							<li class="small-12">
								<div class="small-12 emptyResults flex justify-center">
									<picture class="small-12 flex justify-center">
										<img width="120" :src="empty_image" alt="Nestd Logo in a House">
									</picture>
									<h6 class="small-12 text-center">
										0 results found
									</h6>
									<p class="small-12 text-center">
										No properties have been created at this time.
									</p>
									<div class="small-12 flex justify-center action" v-if="user.relationships.company">
										<router-link :to="{ name: 'AddProperty' }" class="blueButton flex vertical-align justify-center borderRadius4">
											<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
											Add Property
										</router-link>
									</div>
									<div class="small-12 flex justify-center action" v-else>
										<router-link :to="{ name: 'AddCompany' }" class="purpleButton flex vertical-align justify-center borderRadius4">
											<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
											Add Company
										</router-link>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>

	// Import the components
	import PropertyListing from '@/components/properties/dashboard/PropertyListing.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertiesListing',

		/*
		**  Register the components
		*/

		components: {

			PropertyListing

		},

		/*
		**  Set the props
		*/

		props: {

			properties: {
				type: Array,
				default: () => null
			},
			total_properties: {
				type: Number,
				default: 0
			},
			user: {
				type: Object,
				default: () => null
			},
			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-house.svg?alt=media&token=782a6239-e56b-4366-9ed5-b278ad5ea9e4',
			search_query: '',
			future_item: false

		}),

		/*
		**  Set up the methods
		*/

		methods: {

			updateProperties: function(value) {

				// Emit the custom event (custom event name, new value)
				if (value) this.$emit('deleteProperty', true);

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			searchResults: function () {

				if (this.search_query && this.properties.length > 0) {

					return this.properties.filter((item)=>{

						return item.attributes.title.toLowerCase().includes(this.search_query.toLowerCase());

					});

				} else {

					return this.properties;

				}

			}

		}

	}

</script>